import request from '@/utils/request'

// 提交用户反馈（支持文件上传）
export function submitFeedbackWithFiles(formData) {
  return request({
    url: '/api/v1/feedback/with-files',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 提交用户反馈（无文件上传）
export function submitFeedback(data) {
  return request({
    url: '/api/v1/feedback/',
    method: 'post',
    data
  })
}

// 获取当前用户的反馈历史
export function getUserFeedback(params) {
  return request({
    url: '/api/v1/feedback',
    method: 'get',
    params
  })
}

// 管理员获取所有用户反馈 (包含总数)
export function getAdminFeedback(params) {
  return request({
    url: '/api/v1/feedback/admin',
    method: 'get',
    params
  })
}

// 管理员获取反馈总数
export function getAdminFeedbackCount(params) {
  return request({
    url: '/api/v1/feedback/admin/count',
    method: 'get',
    params
  })
}

// 更新反馈状态和处理说明
export function updateFeedback(feedbackId, data) {
  return request({
    url: `/api/v1/feedback/${feedbackId}`,
    method: 'put',
    data
  })
}

// 导出反馈数据为CSV
export function exportFeedback(params) {
  return request({
    url: '/api/v1/feedback/admin/export',
    method: 'get',
    params,
    responseType: 'blob',
    returnFullResponse: true  // 确保返回完整响应对象，包含响应头信息
  })
}

// 获取文件预签名URL
export function getFilePresignedUrl(objectName) {
  return request({
    url: '/api/v1/feedback/file/presigned-url',
    method: 'get',
    params: {
      object_name: objectName
    }
  })
} 